import { createSlice } from "@reduxjs/toolkit";
import { unregisterServiceWorker } from '../utils/serviceWorkerHelper';

const initialState = {
  user: null,
  userData: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, { payload }) => {
      state.user = payload;
      state.userData = payload.data.data;
      window.localStorage.setItem("uni-panel-myuser", JSON.stringify(payload));
    },
    logout: (state, { payload }) => {
      state.user = null;
      state.userData = null;
      window.localStorage.removeItem("uni-panel-myuser");
     unregisterServiceWorker();
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
